enum IntervalTypeEnum {
    HOURLY = 1,
    DAILY,
    WEEKLY,
    MONTHLY,
    QUARTERLY,
    SEMIANNUALLY,
    ANNUALLY,
    FIFTEEN_MIN,
    THIRTY_MIN,
}

export default IntervalTypeEnum;
